import { render, staticRenderFns } from "./CollegeCollect.vue?vue&type=template&id=35c4913c&scoped=true"
import script from "./CollegeCollect.vue?vue&type=script&lang=js"
export * from "./CollegeCollect.vue?vue&type=script&lang=js"
import style0 from "./CollegeCollect.vue?vue&type=style&index=0&id=35c4913c&prod&lang=less"
import style1 from "./CollegeCollect.vue?vue&type=style&index=1&id=35c4913c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4913c",
  null
  
)

export default component.exports